import { type ReactNode } from 'react'
import { openIntercomArticle } from '@util'
import { isNotDefined, type Milestone } from '@terros/common'
import { type MantineSize, Pill } from '@mantine/core'
import { INTERCOM_ARTICLES } from '@front/model'

type Props = {
  milestone?: Milestone
  size?: MantineSize
  showArticle?: boolean
}

export const MilestonePill = ({ milestone, size, showArticle }: Props): ReactNode => {
  if (isNotDefined(milestone)) return
  const onClick = showArticle ? () => openIntercomArticle(INTERCOM_ARTICLES.featureMilestone) : undefined
  return (
    <Pill onClick={onClick} size={size} className={showArticle ? 'cursor-pointer' : undefined}>
      {milestone}
    </Pill>
  )
}
